export const getReviewActionOptions = (hasPermission: boolean, setReviewModalMode: (mode: 'single' | 'all' | null) => void) =>
  hasPermission
    ? [
        {
          label: 'Review for Selected Version',
          value: 'review_for_selected_version',
          onClick: () => setReviewModalMode('single'),
        },
        {
          label: 'Review for Future Versions',
          value: 'review_for_future_versions',
          onClick: () => setReviewModalMode('all'),
        },
      ]
    : [];
